import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getGroupById } from "../api/group";
import logo from "../assets/hemmexus.png";
import fondoMarcador from "../assets/bg/fondo-marcador.png";
import { useTimer } from "../hooks/useTimer";
import { updateTime } from "../redux/actions";
import { GAME_TIME_SECS, ROUTES } from "../utils/constants";
import {
	formatMinutes,
	formatSeconds,
	getTimer,
	updateStats,
	updateTimer,
	setLastTickNow,
	getLastTick,
	setLastTick 
} from "../utils/helpers";
import { modalIntro, modalText } from "../utils/logger";

export default function TopBar() {
	const timeout = GAME_TIME_SECS;
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const game = useSelector((state) => state.game);
	const [group, setGroup] = useState(useSelector((state) => state.group));
	//const [time, setTime] = useState(parseInt(group?.time));
	//let isACTIVE = false;
	const [score, setScore] = useState(group?.score || 0);

	const [time, setTime] = useState(() => {
		const saved = getTimer();
		const n = saved !== null ? Number(saved) : parseInt(group?.time || 0, 10);
		return Number.isFinite(n) ? n : 0;
	});

	/*
	useTimer(() => {
		if (!isACTIVE && getTimer()) isACTIVE = true;
		if (isACTIVE) handleTimer();
	}, 1000);
	*/
	useTimer(() => {
		handleTimer();
	}, 1000);

	/*
	const handleTimer = () => {
		if (!getTimer()) isACTIVE = false;
		else {
			setTime(time + 1);
			updateTimer(time);
		}
	};
	*/

	useEffect(() => {
	  if (getTimer() !== null && !getLastTick()) setLastTickNow();
	}, []);

	const handleTimer = () => {
		// Si no hay contador, no corremos
		if (getTimer() === null) return;
		const now = Date.now();
		const prevTick = getLastTick() ?? now;
		const deltaMs  = now - prevTick;
		const deltaSec = Math.floor(deltaMs / 1000);
		if (deltaSec <= 0) return;
		setTime((prev) => {
			const next = prev + deltaSec;
			updateTimer(next);
			setLastTick(prevTick + deltaSec * 1000);
			return next;
		});
	};

	useEffect(() => {
		const onVis = () => {
			if (document.visibilityState === "visible") {
			handleTimer(); // actualiza de golpe lo pasado en 2º plano
			}
		};
		document.addEventListener("visibilitychange", onVis);
		return () => document.removeEventListener("visibilitychange", onVis);
	}, []);

	useEffect(() => {
		if (
			time >= timeout &&
			group.lastVisited !== ROUTES.GAMEOVER &&
			!game?.demo
		) {
			dispatch(updateTime(time));
			updateStats({
				...group,
				time: time,
				lastVisited: ROUTES.GAMEOVER,
				finished: true,
			});
			navigate(ROUTES.GAMEOVER);
		} else if (group?.finished) {
			navigate(group?.lastVisited || ROUTES.RESULTS);
		}
	}, [time, group, game, navigate, dispatch]);

	useEffect(() => {
		if (group) {
			getGroupById(group?._id)
				.then((res) => {
					if (res.status === 200) {
						let group = res.data;
						let score = group?.score;
						setScore(score);
					}
				})
				.catch((error) => {});
		}
	}, [location]);

	const REFERENCIAS = `
	<div class="w-100 px-4" style="text-align: left;">
		<h3 class="txtTitulos black bold">
			REFERENCIAS BIBLIOGRÁFICAS SINFONÍA HEMMEXUS
		</h3>
		<p class="txtTexto1 black">
			<ul>
				<li>A Study of JNJ-68284528, a Chimeric Antigen Receptor T Cell (CAR-T) Therapy Directed Against B-Cell Maturation Antigen (BCMA) in Participants With Relapsed or Refractory Multiple Myeloma (CARTITUDE-1). Clinicaltrials.gov [Internet] [consulta el 19 de marzo de 2026]. Disponible en: https://clinicaltrials.gov/study/NCT03548207NCT04035226.</li>
				<li>A Study of Real-Life Current Standards of Care in Participants With Relapsed and/or Refractory Multiple Myeloma (MoMMent) Clinicaltrials.gov [Internet] [consulta el 19 de marzo de 2026]. Disponible en: https://clinicaltrials.gov/study/NCT05160584.</li>
				<li>A Study of Talquetamab in Participants With Relapsed or Refractory Multiple Myeloma (MonumenTAL-1). Clinicaltrials.gov [Internet] [consulta el 19 de marzo de 2026]. Disponible en: https://www.clinicaltrials.gov/study/NCT04634552.</li>
				<li>A Study of Teclistamab in Participants With Relapsed or Refractory Multiple Myeloma (MajesTEC-1). Clinicaltrials.gov [Internet] [consulta el 19 de marzo de 2026]. Disponible en: https://www.clinicaltrials.gov/study/NCT04557098.</li>
				<li>Bruins WSC, Zweegman S, Mutis T, van de Donk NWCJ. Targeted Therapy With Immunoconjugates for Multiple Myeloma. Front Immunol. 2020 Jun 19;11:1155. doi: 10.3389/fimmu.2020.01155.</li>
				<li>CAR-T cell therapy. National Cancer Institute [Internet]. Cancer.gov. 2011 [consulta el 19 de marzo de 2026]. Disponible en: https://www.cancer.gov/publications/dictionaries/cancer-terms/def/chimeric-antigen-receptor-t-cell-therapy.</li>
				<li>Cheruvalath H, Clennon A, Shrestha A, et al. Effects of Intravenous Immunoglobulin Supplementation (IVIG) on Infections in Recipients of Teclistamab Therapy for Multiple Myeloma (MM): A Multi-Institutional Study. Blood. 2024;144(1):256-7.</li>
				<li>Lee HC, Bumma N, Richter JR, et al. LINKER-MM1 study: Linvoseltamab (REGN5458) in patients with relapsed/refractory multiple myeloma. ASCO 2023; abstract 8006.</li>
				<li>Li J, Stagg NJ, Johnston J, et al. Membrane-Proximal Epitope Facilitates Efficient T Cell Synapse Formation by Anti-FcRH5/CD3 and Is a Requirement for Myeloma Cell Killing. Cancer Cell. 2017 Mar 13;31(3):383-95. doi: 10.1016/j.ccell.2017.02.001.</li>
				<li>Ludwig H, Terpos E, van de Donk N, et al. Prevention and management of adverse events during treatment with bispecific antibodies and CAR T cells in multiple myeloma: a consensus report of the European Myeloma Network. Lancet Oncol. 2023 Jun;24(6):e255-e269. doi: 10.1016/S1470-2045(23)00159-6.</li>
				<li>Mateos M-V, et al. IMS 2023: poster [294].</li>
				<li>Mateos MV, Weisel K, De Stefano V, et al. LocoMMotion: a prospective, non-interventional, multinational study of real-life current standards of care in patients with relapsed and/or refractory multiple myeloma. Leukemia. 2022 May;36(5):1371-6. doi: 10.1038/s41375-022-01531-2.</li>
				<li>Mian H, Tan CR, Asoori S, et al. Outcomes of frailty subgroups treated with teclistamab in the real-world: An International Myeloma Foundation study database analysis. Blood [Internet]. 2024 [consulta el 19 de marzo de 2026];144(Supplement 1):704. Disponible en: https://ash.confex.com/ash/2024/webprogram/Paper200877.html.</li>
				<li>Moreau P, Garfall AL, van de Donk NWCJ, et al. Teclistamab in Relapsed or Refractory Multiple Myeloma. N Engl J Med. 2022 Aug 11;387(6):495-505. doi: 10.1056/NEJMoa2203478.</li>
				<li>Pasvolsky O, Milton DR, Jatoi A, et al. Outcomes of multiple myeloma patients undergoing autologous transplant with suboptimal pre-transplant response. ASH 2024; abstract P1310.</li>
				<li>Pillarisetti K, Powers G, Luistro L, et al. Teclistamab is an active T cell-redirecting bispecific antibody against B-cell maturation antigen for multiple myeloma. Blood Adv. 2020 Sep 22;4(18):4538-49. doi: 10.1182/bloodadvances.2020002393.</li>
				<li>Raje N, Anderson K, Einsele H, et al. Monitoring, prophylaxis, and treatment of infections in patients with MM receiving bispecific antibody therapy: consensus recommendations from an expert panel. Blood Cancer J. 2023 Aug 1;13(1):116. doi: 10.1038/s41408-023-00879-7.</li>
				<li>Raje NS, Anaissie E, Kumar SK, et al. Consensus guidelines and recommendations for infection prevention in multiple myeloma: a report from the International Myeloma Working Group. Lancet Haematol. 2022 Feb;9(2):e143-e161. doi: 10.1016/S2352-3026(21)00283-0.</li>
				<li>Rasche L, Schinke CD, Tozeau C, et al. Efficacy and safety from the phase 1/2 MonumenTAL-1 study of talquetamab, a GPRC5D×CD3 bispecific antibody, in patients with relapsed/refractory multiple myeloma: Analyses at an extended median follow-up. J Clin Oncol. 2025;43:7528. https://ascopubs.org/doi/10.1200/JCO.2025.43.16_suppl.7528.</li>
				<li>Rodríguez-Lobato LG, Ganzetti M, Fernández de Larrea C, Hudecek M, Einsele H, Danhof S. CAR T-Cells in Multiple Myeloma: State of the Art and Future Directions. Front Oncol. 2020 Jul 28;10:1243. doi: 10.3389/fonc.2020.01243.</li>
				<li>Smith EL, Harrington K, Staehr M, et al. GPRC5D is a target for the immunotherapy of multiple myeloma with rationally designed CAR T cells. Sci Transl Med. 2019 Mar 27;11(485):eaau7746. doi: 10.1126/scitranslmed.aau7746.</li>
				<li>Tomasson et al. ASH 2023 (Abstract No. 3385 – oral presentation).</li>
				<li>Van de Donk NWCJ, et al. ASCO 2023 (Abstract No. 8011 – presentation); 387:495-505.</li>
				<li>Van de Donk NWCJ, Moreau P, Garfall AL, et al. Long-term follow-up from MajesTEC-1 of teclistamab, a B-cell maturation antigen (BCMA) x CD3 bispecific antibody,in patients with relapsed/refractory multiple myeloma (RRMM). J Clin Oncol. 2023;41(16 suppl):Abstract 8011.</li>
				<li>Verkleij CPM, Korst CLBM, van de Donk NWCJ. Immunotherapy in multiple myeloma: when, where, and for who? Curr Opin Oncol. 2020 Nov;32(6):664-71. doi: 10.1097/CCO.0000000000000677.</li>
				<li>Verkleij et al. Blood Advances. 2020;5(8);2195-215.</li>
				<li>Vij R et al. ASH 2023 (Abstract No. 3378 – poster).</li>
				<li>Voorhees, Martin TG, Lin Y, et al. Long-term (≥5 year) remission and survival after treatment with ciltacabtagene autoleucel in CARTITUDE-1 patients with relapsed/refractory multiple myeloma. ASCO 2025: poster. Disponible en: https://www.jnjmedicalconnect.com/media/attestation/congresses/oncology/2025/am/longterm-5-year-remission-and-survival-after-treatment-with-ciltacabtagene-autoleucel-ciltacel-in-ca.pdf.</li>
				<li>Weissel K. P-325: Standard of Care (SOC) Outcomes in the Last 3 Years in Patients With Triple-Class Exposed (TCE) Relapsed/Refractory Multiple Myeloma (RRMM): The First Pooled Analysis of LocoMMotion and MoMMent Trials. EHA 2025.</li>
				<li>Yu B, Jiang T, Liu D. BCMA-targeted immunotherapy for multiple myeloma. J Hematol Oncol. 2020 Sep 17;13(1):125. doi: 10.1186/s13045-020-00962-7.</li>
			</ul>
		</p>
	</div>
	`;

	return (
		<div className="py-2" style={{ overflow: "visible" }}>
		<div className="row d-flex justify-content-between align-items-center legalGebro px-4" style={{ overflow: "visible", minHeight: "56px" }}>
			{/* Logo */}
			<div className="col-4 d-flex justify-content-start align-items-center txtTexto2 txtRed">
				<img
					className="mr-2"
					src={logo}
					alt="decorativo"
					style={{
						maxWidth: "40px",
						marginRight: "14px",
					}}
				/>
				<span>{group?.fullName || "NOMBRE DEL EQUIPO"}</span>
				<span
					className="px-2 ms-3 rounded"
					style={{
						border: "1px #b1000d dashed",
						borderRadius: "12px",
						minWidth: "60px",
						fontSize: "16px",
						fontWeight: "bold",
						color: "#b1000d",
						height: "fit-content"
					}}
				>Equipo nº{group?.tableNum || 0}
				</span>
			</div>

			{/* Marcador de puntos: fondo alto que se sobrepone por debajo de la barra */}
			<div className="col-4 d-flex align-items-center justify-content-center" style={{ overflow: "visible", position: "relative", zIndex: 1000, minHeight: "56px" }}>
				<div
					className="d-flex align-items-center justify-content-center px-4"
					style={{
						backgroundImage: `url(${fondoMarcador})`,
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center",
						backgroundSize: "contain",
						minWidth: "80px",
						minHeight: "80px",
						position: "absolute",
						bottom: 0,
						left: "50%",
						transform: "translateX(-50%) translateY(20%)",
					}}
				>
					<div className="txt36 bold" style={{ color: "black" }}>
						{score}
					</div>
				</div>
			</div>

			{/* Derecha: icono i, Bibliografía, timer; barra de tiempo debajo solo desde "i" hasta el contador */}
			<div className="col-4 d-flex flex-column align-items-end">
				<div className="d-inline-flex flex-column align-items-stretch">
					<div className="d-flex align-items-center flex-nowrap">
						<button
							type="button"
							className="topBar-headerIcon topBar-headerIcon--sm"
							onClick={() => modalIntro()}
							title="Instrucciones"
							aria-label="Instrucciones"
						>
							i
						</button>
						<button
							type="button"
							className="topBar-headerBtn topBar-headerBtn--sm"
							onClick={() => modalText({ html: REFERENCIAS })}
						>
							Bibliografía
						</button>
						<div className="d-flex align-items-center topBar-timerWrap">
							<div className="timer timer--sm">
								{formatMinutes(time, timeout, group?.finished)}
							</div>
							<span className="topBar-timerColon blink">:</span>
							<div className="timer timer--sm">
								{formatSeconds(time, timeout, group?.finished)}
							</div>
						</div>
					</div>
					<div className="time-progress-bar mt-2">
						<div
							className="time-progress-fill"
							style={{
								width: `${Math.min(100, (time / timeout) * 100)}%`,
							}}
						/>
						<div
							className="time-progress-handle"
							style={{
								left: `${Math.min(100, (time / timeout) * 100)}%`,
							}}
							aria-hidden
						/>
					</div>
				</div>
			</div>
		</div>
		</div>
	);

}
